import { render, staticRenderFns } from "./ListarRegiao.vue?vue&type=template&id=3b9d6186"
import script from "./ListarRegiao.vue?vue&type=script&lang=js"
export * from "./ListarRegiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports